module.exports = __webpack_public_path__ + "static/media/ufc-icon.5d56b918.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ufc-icon.png
// module id = 350
// module chunks = 0